import { atom } from "jotai";

// True while GET /invoices/me (#215) is in flight. An in-flight flag, so it
// stays out of the sign-out reset; the Billing History page derives its own
// per-query state and does not read it.
export const isFetchingMeInvoicesAtom = atom<boolean>(false);

// Billing History's Filters drawer. The page renders the drawer only while
// this is true, and closes it when the page unmounts so it cannot reopen on
// the next visit.
export const isInvoiceFiltersOpenAtom = atom<boolean>(false);
